import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"
import { OnRampWidgetStepUi } from "@src/widgets/onboarding/ui/tours/OnRampWidget/steps/OnRampWidgetStepUi"

export class OnRampWidgetStep extends TourStepBase {
  component = OnRampWidgetStepUi
  name = `${ONBOARDING_TOURS.ON_RAMP_WIDGET}_OnRampWidget`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_CREATEBUTTON_BUTTON_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.widgets,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Extra feature for your clients to buy crypto",
      title: "On-Ramp Widget",
    }
  }
}
